<script setup lang="ts">
import { computed } from 'vue'

type LifecycleFilter = 'all' | 'raising' | 'closed' | 'exited'

interface PillStyle {
  active: string
  inactive: string
  count: string
}

const props = defineProps<{
  filterKey: LifecycleFilter
  label: string
  count: number
  active: boolean
}>()

const emit = defineEmits<{
  (e: 'select'): void
}>()

const STYLES: Record<LifecycleFilter, PillStyle> = {
  all: {
    active: 'border-[#346c74] text-[#346c74] bg-[#e6f0f1]',
    inactive: 'border-transparent text-[#346c74] bg-[#e6f0f1] hover:bg-[#d6e4e6]',
    count: 'text-[#346c74]',
  },
  raising: {
    active: 'border-[#059669] text-[#059669] bg-[#ecfdf5]',
    inactive: 'border-transparent text-[#059669] bg-[#ecfdf5] hover:bg-[#d1fae5]',
    count: 'text-[#059669]',
  },
  closed: {
    active: 'border-[#3092b3] text-[#3092b3] bg-[#e0f0f5]',
    inactive: 'border-transparent text-[#3092b3] bg-[#e0f0f5] hover:bg-[#c8e6f0]',
    count: 'text-[#3092b3]',
  },
  exited: {
    active: 'border-[#246586] text-[#246586] bg-[#d6e4f0]',
    inactive: 'border-transparent text-[#246586] bg-[#d6e4f0] hover:bg-[#bdd4e8]',
    count: 'text-[#246586]',
  },
}

const containerClass = computed(() => {
  const s = STYLES[props.filterKey]
  return props.active ? s.active : s.inactive
})

const countClass = computed(() => STYLES[props.filterKey].count)
</script>

<template>
  <button
    type="button"
    class="inline-flex items-center gap-2 rounded-md border px-3 py-1.5 text-xs font-semibold transition"
    :class="containerClass"
    @click="emit('select')"
  >
    <span>{{ label }}</span>
    <span class="text-[10px] font-bold tabular-nums" :class="countClass">{{ count }}</span>
  </button>
</template>
